const getPrismicPlainText = (field) => {
  if (!field) return '';
  if (typeof field === 'string') return field.trim();
  if (typeof field.text === 'string') return field.text.trim();
  if (Array.isArray(field) && typeof field[0]?.text === 'string') {
    return field[0].text.trim();
  }
  return '';
};

export const findLinkedTeamMember = (teamMembers, authorLink) => {
  if (!authorLink || !teamMembers?.length) return null;

  const uid = authorLink.uid?.trim?.() || authorLink.uid;
  const id = authorLink.id;

  if (uid) {
    const byUid = teamMembers.find((node) => node?.uid === uid);
    if (byUid) return byUid;
  }

  if (id) {
    const byId = teamMembers.find((node) => node?.id === id);
    if (byId) return byId;
  }

  return null;
};

export const findTeamMemberByName = (teamMembers, name) => {
  const normalized = typeof name === 'string' ? name.trim().toLowerCase() : '';
  if (!normalized || !teamMembers?.length) return null;

  const exact = teamMembers.find(
    (node) => getPrismicPlainText(node?.data?.name).toLowerCase() === normalized
  );
  if (exact) return exact;

  return (
    teamMembers.find((node) => {
      const memberName = getPrismicPlainText(node?.data?.name).toLowerCase();
      if (!memberName) return false;
      return memberName.includes(normalized) || normalized.includes(memberName);
    }) || null
  );
};

/** Team member for About the Author. Falls back to the default Lineage author. */
export function resolveArticleAuthorMember(articleAuthorLink, teamMembers, bylineName, defaultAuthorLabel) {
  const fromList = findLinkedTeamMember(teamMembers, articleAuthorLink);
  if (fromList) return fromList;

  const linkDocData = articleAuthorLink?.document?.data;
  if (linkDocData && (articleAuthorLink?.uid || articleAuthorLink?.id)) {
    const named = findTeamMemberByName(teamMembers, getPrismicPlainText(linkDocData.name));
    if (named) return named;

    return {
      uid: articleAuthorLink.uid,
      id: articleAuthorLink.id,
      data: linkDocData,
    };
  }

  const fromByline = findTeamMemberByName(teamMembers, bylineName);
  if (fromByline) return fromByline;

  return findTeamMemberByName(teamMembers, defaultAuthorLabel);
}

/**
 * Byline name for Lineage read articles (Prismic).
 * Priority: byline_author text → linked Author (team member) → optional default from UI.
 */
export function resolveReadBylineAuthor(
  { bylineAuthor, articleAuthorLink, teamMembers = [] },
  defaultAuthor
) {
  const customName = typeof bylineAuthor === 'string' ? bylineAuthor.trim() : '';
  if (customName) {
    return customName;
  }

  const fromLinkedDoc = getPrismicPlainText(articleAuthorLink?.document?.data?.name);
  if (fromLinkedDoc) {
    return fromLinkedDoc;
  }

  const member = findLinkedTeamMember(teamMembers, articleAuthorLink);
  const linkedName = getPrismicPlainText(member?.data?.name);
  if (linkedName) {
    return linkedName;
  }

  return defaultAuthor;
}
